export class EmpregadorIdade {
  public idadeMaxima!: number;
  public fatorRMC!: number;
  public valorMaximo!: string;
}